import React from "react";

import CheckoutForm from "../../layout/CheckoutForm";

const RenewPayment = (props) => {
  return (
    <>
      <div className="cpay">
        <h1 className="cpay-title text-jost-sb-50-wt">
          Sign up your club today
        </h1>

        <div className="cpay__wrap">
          <div className="cpay__bar">
            <ul className="cpay__bar__row">
              <li className="text-jost-sb-22 completed">CLUB Details</li>
              <li className="text-jost-sb-22 completed ">Golf Courses</li>
              <li className="text-jost-sb-22 active">Payment DETAILS</li>
              <li className="text-jost-sb-22">Confirmation</li>
            </ul>
          </div>
          
          <CheckoutForm Data={props.users} {...props} />
        </div>
      </div>
    </>
  );
};

export default RenewPayment;
